const investmentTypeColors: Record<string, string> = {
  'Greenfield expansion': '#409D74',
  'Brownfield expansion': '#967441',
  'IPO': '#7B1FA2',
  'Funding': '#F9A825',
  'M&A': '#D84315',
};

const investmentStatusColors: Record<string, string> = {
  'announced': '#1976D2',
  'in progress': '#F57C00',
  'finished': '#2E7D32',
  'cancelled': '#D32F2F',
};

export const ALL_INVESTMENT_TYPES = Object.keys(investmentTypeColors);

export const PHYSICAL_TYPES = ['Greenfield expansion', 'Brownfield expansion'];
export const FINANCIAL_TYPES = ['IPO', 'Funding', 'M&A'];

export function getTypeColor(type: string | null): string {
  return investmentTypeColors[type || ''] || '#9E9E9E';
}

export function getStatusColor(status: string | null): string {
  return investmentStatusColors[status || ''] || '#9E9E9E';
}
